import { render, staticRenderFns } from "./Gradingly.vue?vue&type=template&id=3971364c"
import script from "./Gradingly.vue?vue&type=script&lang=js"
export * from "./Gradingly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports